<template>
  <nuttrema-layout-content>

    <my-preferences-standard-header
       slot="header"
      :meta="meta"
      :edit.sync="edit"
      :PersonalProfile="PersonalProfile">
      <div slot="edit" class="content-header-item">
        <permissions-control-wrapper
           action="label.edit"
          :required-general="$PERMISSIONS_GENERAL.SECURITY"
          :permissions="_get(PersonalProfile, 'meta.permissions')">
          <edit-lock-button slot="allowed" :edit.sync="edit"></edit-lock-button>
          <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
        </permissions-control-wrapper>
      </div>
    </my-preferences-standard-header>

    <template slot="central">
      <nuttrema-loader v-if="PersonalProfile.fetching"></nuttrema-loader>
      <form-my-preferences-change-status
           v-else
          :edit.sync="edit"
          :PersonalProfile="PersonalProfile"
          :PersonalStatistics="PersonalStatistics"
          @submit="onFormSubmit">
        </form-my-preferences-change-status>
      </template>
    </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import MyPreferencesStandardHeader from 'components/pages/professional/settings/my-preferences/shared/cmpt-my-preferences-standard-header';

import FormMyPreferencesChangeStatus from './form-my-preferences-change-status';

export default {
  name: 'page-my-preferences-change-status',
  mixins: [
    PageProps,
  ],
  data() {
    return {
      edit: false,
    };
  },
  components: {
    NuttremaLayoutContent,
    MyPreferencesStandardHeader,
    FormMyPreferencesChangeStatus,
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    PersonalStatistics() {
      return this.$store.getters.PersonalStatistics;
    },
  },
  methods: {
    ...mapActions([
      'PersonalDeactivateAccount',
    ]),
    onFormSubmit(payload) {
      this.PersonalDeactivateAccount({ payload }).then(() => {
        this.successNotification({ message: 'message.account_deactivated' });
        this.$router.push({ name: this.PAGES.PROFESSIONAL.LOGOUT });
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
  },
  created() {
    this.$store.dispatch('GetPersonalStatistics');
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonalStatistics');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/status/page-my-preferences-change-status.vue